module.exports = __webpack_public_path__ + "img/admin_adv_04.c9055871.png";